import { useCallback } from 'react';
import { letterGenerationsService } from '../services';
import {
  useResourceCollection,
  useCreateResource,
  useDeleteResource,
  ResourceState,
  MutationState,
} from './useResource';
import { ResourceQueryOptions } from '../services/resources.service';
import { LetterGeneration } from '../types';

export function useLetterGenerations(
  options?: ResourceQueryOptions
): ResourceState<LetterGeneration> & { meta?: any } {
  const fetchFn = useCallback(
    (opts?: ResourceQueryOptions) =>
      letterGenerationsService.getAll(opts) as unknown as Promise<{ data: LetterGeneration[]; meta?: any }>,
    []
  );
  return useResourceCollection<LetterGeneration>(fetchFn, options);
}

export function useCreateLetterGeneration(
  onSuccess?: (data: LetterGeneration) => void
): MutationState<LetterGeneration> {
  const createFn = useCallback(
    (data: any) => letterGenerationsService.create(data) as unknown as Promise<LetterGeneration>,
    []
  );
  return useCreateResource<LetterGeneration>(createFn, onSuccess);
}

export function useDeleteLetterGeneration(onSuccess?: () => void): MutationState<void> {
  const deleteFn = useCallback(
    (data: any) => {
      const documentId = data.documentId || data.id?.toString() || data.id;
      return letterGenerationsService.delete(documentId) as unknown as Promise<void>;
    },
    []
  );
  return useDeleteResource(deleteFn, onSuccess);
}
